import React, { useState, useEffect } from 'react';
import ShareButton from '../common/ShareButton';

const ProductModal = ({ isOpen, onClose, product }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Combine main image and gallery images, filtering out any empty strings/undefined
    const allImages = product ? [product.imageUrl, ...(product.images || [])].filter(Boolean) : [];

    // Reset carousel when product changes
    useEffect(() => {
        setCurrentIndex(0);
    }, [product?.id]);

    // 3-second Auto Carousel
    useEffect(() => {
        if (allImages.length <= 1 || !isOpen) return;

        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % allImages.length);
        }, 3000);

        return () => clearInterval(timer);
    }, [allImages.length, currentIndex, isOpen]);

    if (!isOpen || !product) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.7)', zIndex: 2000,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            padding: '1rem'
        }} onClick={onClose}>
            <div style={{
                background: 'white', width: '100%', maxWidth: '800px', maxHeight: '90vh',
                borderRadius: '12px', overflowY: 'auto', position: 'relative',
                display: 'flex', flexDirection: 'column'
            }} onClick={e => e.stopPropagation()}>

                {/* Header */}
                <div style={{
                    padding: '1.5rem 2rem', borderBottom: '1px solid #eee',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    position: 'sticky', top: 0, background: 'white', zIndex: 10
                }}>
                    <h2 style={{ fontSize: '1.4rem', fontWeight: 'bold', margin: 0 }}>{product.name}</h2>
                    <button onClick={onClose} style={{
                        background: 'none', border: 'none', fontSize: '2rem', cursor: 'pointer', color: '#888', lineHeight: 1
                    }}>&times;</button>
                </div>

                <div style={{ padding: '2rem' }}>
                    {/* Large Main Viewer */}
                    {allImages.length > 0 && (
                        <div style={{
                            width: '100%', height: '350px',
                            borderRadius: '12px', overflow: 'hidden', marginBottom: '1.5rem',
                            background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            border: '1px solid #f0f0f0', boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.02)'
                        }}>
                            <img
                                src={allImages[currentIndex]}
                                alt={`${product.name} 뷰어`}
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', transition: 'opacity 0.3s ease-in-out' }}
                            />
                        </div>
                    )}

                    {/* Image Gallery Thumbnails (Horizontal Scroll) */}
                    {allImages.length > 1 && (
                        <div style={{
                            display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '1rem', marginBottom: '2rem',
                            scrollbarWidth: 'thin', scrollbarColor: '#dcdcdc transparent'
                        }}>
                            {allImages.map((img, idx) => (
                                <div 
                                    key={idx} 
                                    onClick={() => setCurrentIndex(idx)}
                                    style={{
                                        flex: '0 0 auto', width: '90px', height: '90px',
                                        borderRadius: '8px', overflow: 'hidden', border: currentIndex === idx ? '2px solid var(--primary-color, #0056b3)' : '1px solid #eee',
                                        background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        boxShadow: currentIndex === idx ? '0 4px 10px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)',
                                        cursor: 'pointer', transition: 'all 0.2s', opacity: currentIndex === idx ? 1 : 0.6
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = currentIndex === idx ? '1' : '0.6'}
                                >
                                    <img src={img} alt={`${product.name} 썸네일 ${idx}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Description */}
                    {product.description && (
                        <div style={{ marginBottom: '2.5rem', lineHeight: '1.7', color: '#444', fontSize: '1.05rem', whiteSpace: 'pre-wrap' }}>
                            {product.description}
                        </div>
                    )}

                    {/* Specifications Table */}
                    {product.specs && Object.keys(product.specs).length > 0 && (
                        <div>
                            <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem', borderLeft: '4px solid var(--primary-color, #0056b3)', paddingLeft: '10px' }}>제품 규격 (Specifications)</h3>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95rem' }}>
                                <tbody>
                                    {Object.entries(product.specs).map(([key, value], idx) => (
                                        <tr key={key} style={{ borderBottom: '1px solid #eee', backgroundColor: idx % 2 === 0 ? '#fcfcfc' : 'white' }}>
                                            <td style={{
                                                padding: '12px 16px', fontWeight: '600', color: '#555', width: '35%',
                                                borderRight: '1px solid #eee'
                                            }}>{key}</td>
                                            <td style={{ padding: '12px 16px', color: '#333' }}>{value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Social Share Module */}
                    <ShareButton 
                        url={`${window.location.origin}/products/${product.id}`}
                        title={`[가까운솔루션] ${product.name}`}
                        description={product.description}
                        imageUrl={allImages && allImages.length > 0 ? allImages[0] : null}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProductModal;
